export const DEFAULT_TIMEZONE = 'Asia/Bangkok'

// Format
export const DATE_TIME_FORMAT = 'YYYY-MM-DD HH:mm'
export const DATE_TIME_FORMAT_HUMAN = 'D MMM YYYY HH:mm'
export const DATE_TIME_SECOND_FORMAT_HUMAN = 'D MMM YYYY HH:mm:ss'
export const DATE_TIME_FORMAT_HUMAN_SHORT = 'D MMM HH:mm'
export const DATE_FORMAT = 'MM/DD/YYYY'
export const DATE_FORMAT_QUERY = 'YYYY-MM-DD'
export const DATE_FORMAT_HUMAN = 'D MMM YYYY'
